import type { ChartCardDefaults } from '../types'
import { useChartCardConstants } from './useChartCardConstants'

export const useChartCardDefaults = (): ChartCardDefaults => {
  const { defaults } = useChartCardConstants()
  return defaults
}
